import { useEffect } from 'react';

// Fase 0 — intro sobria de COWRE (dark). Reveal del logo (cowre.png) + wordmark
// + tagline, auto-avanza a los ~2.8s; también avanza al tocar. Animaciones en
// experience.css (respetan prefers-reduced-motion).
export default function Intro({ onDone }) {
    useEffect(() => {
        const t = setTimeout(onDone, 2800);
        return () => clearTimeout(t);
    }, [onDone]);

    return (
        <div className="evx__intro" onClick={onDone} role="button" tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onDone(); }}>
            <div className="evx__intro-glow" aria-hidden="true" />
            <div className="evx__intro-mark">
                <img className="evx__intro-logo" src="/cowre.png" alt="COWRE" />
            </div>
            <h1 className="evx__intro-word">COWRE</h1>
            <p className="evx__intro-tag">Genética demostrable, tuya y rentable.</p>
            <span className="evx__intro-hint">Subasta en vivo · toca para continuar</span>
        </div>
    );
}
